export const paths = {
  home: '/',
  DASHBOARD: '/dashboard',
  page500: '/500',
  page401: '/not-authorized',
  page503: '/service-unavailable',
  logoutPage: '/logout',
};
